(function(){
  function cfg(){ return window.LO_LANDER || {}; }
  function fill(){
    var c = cfg();
    document.querySelectorAll('[data-lo-price]').forEach(function(el){ if (c.price) el.textContent = c.price; });
    document.querySelectorAll('[data-lo-compare]').forEach(function(el){ if (c.compare) el.textContent = c.compare; });
    document.querySelectorAll('[data-lo-label]').forEach(function(el){
      if (!el.dataset.tpl) el.dataset.tpl = el.textContent;
      el.textContent = el.dataset.tpl.replace(/\[price\]/g, c.price || '').replace(/\[compare\]/g, c.compare || '');
    });
  }
  function fail(btn, msg){
    btn.classList.remove('is-loading');
    delete btn.dataset.busy;
    window.alert(msg || 'Sorry, something went wrong. Please try again.');
  }
  function post(url, body){
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(d){ if (!r.ok) throw new Error(d.description || d.message); return d; }); });
  }
  function addAndCheckout(btn){
    var c = cfg();
    if (btn.dataset.busy) return;
    if (!c.variantId) return fail(btn, 'This product is not available right now.');
    btn.dataset.busy = '1';
    btn.classList.add('is-loading');
    var code = (c.discount || '').trim();
    var dest = c.redirect === 'cart' ? '/cart' : '/checkout';
    post('/cart/add.js', { items: [{ id: c.variantId, quantity: 1, selling_plan: null }] })
      .then(function(){
        if (!code) return;
        return post('/cart/update.js', { discount: code }).catch(function(){});
      })
      .then(function(){
        /* /discount/CODE stores the code on the session + cart, then forwards to checkout or cart */
        window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest) : dest;
      })
      .catch(function(e){ fail(btn, e && e.message); });
  }
  document.addEventListener('click', function(e){
    var atc = e.target.closest('[data-lo-atc]');
    if (atc) { e.preventDefault(); addAndCheckout(atc); return; }
    var nav = e.target.closest('[data-lo-rail]');
    if (nav) {
      var sec = nav.closest('.lo-rev');
      var rail = sec && sec.querySelector('.lo-rail');
      if (rail) rail.scrollBy({ left: Number(nav.dataset.loRail) * Math.min(rail.clientWidth * 0.8, 720), behavior: 'smooth' });
    }
  });
  window.addEventListener('pageshow', function(){
    document.querySelectorAll('[data-lo-atc].is-loading').forEach(function(b){ b.classList.remove('is-loading'); delete b.dataset.busy; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  document.addEventListener('shopify:section:load', fill);
})();
